<script lang="ts">
	// Stores
	import { firmwares_gen_2 } from 'src/stores/device-runtime/process';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { getDeviceState } from 'src/stores/device-runtime/states';

	// Services and configs
	import { devices_config } from 'src/configs/devices';
	import { getDeviceChartsConfig } from 'src/components/Chart/chart_config';

	// Helpers
	import { real_id, is_gen_2 } from 'src/helpers/interface_helpers';
	import { getAddonStatus } from 'src/helpers/addons/addon_helpers';
	import { useNavigateToHistoryStatisticsTab } from 'src/components/Sidepanel/useNavigateToHistoryStatisticsTab';

	// Components
	import ControlOnOff from 'src/components/Controls/Single/ControlOnOff.svelte';
	import ControlOnOffAddon from 'src/components/Controls/Single/ControlOnOffAddon.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';
	import ThumbDeviceChartV2 from 'src/components/Chart/ThumbDeviceChartV2.svelte';
	import {
		createGen1StatusLabels,
		getGen1DeviceStatuses,
	} from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import DeviceLabelList from '../DeviceLabelList.svelte';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: deviceConfig = devices_config?.[device?.type];

	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);

	// Device calculations
	$: gen2 = is_gen_2(device);

	// Charts
	$: deviceChartsConfig = device ? getDeviceChartsConfig(device) : [];
	$: fwVersion = settings?.sys?.device.fw_id;
	$: minVersion = $firmwares_gen_2[device?.id]?.stable?.version;

	let deviceState: any = getDeviceState(device?.id);

	const { navigateToHistoryStatisticsTab } = useNavigateToHistoryStatisticsTab();

	const handleOnClickThumbChart = (event: CustomEvent | Event) => {
		navigateToHistoryStatisticsTab();
	};
</script>

<DeviceViewStateWrapper {device}>
	<div slot="staticTop">
		<DeviceLabelList {labelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div class="flex-full-height justify-content-end" slot="staticBottom">
		{#if deviceChartsConfig.length}
			{@const emHasSwitch = 'switch:0' in status}
			{#if !emHasSwitch}
				<ThumbDeviceChartV2 {device} {deviceChartsConfig} on:click={handleOnClickThumbChart} />
			{/if}
		{/if}
		{#if !gen2}
			<ControlOnOff {device} {status} {settings} isWide useV2Components={true} />
		{/if}

		{#if true}
			{@const peripheral = getAddonStatus(device, [], false, true)}
			{@const emHasSwitch = 'switch:0' in status}
			{@const emHasSwitchAddon =
				peripheral && peripheral.find((i) => i.peripheralType == 'switch')}

			{#if emHasSwitchAddon && emHasSwitch}
				<div class="d-flex gap-s">
					<div class="control-flex-column flex-1">
						<ControlOnOffAddon
							{device}
							{status}
							isInSlot
							useV2Components={true}
							component={peripheral.find((i) => i.peripheralType == 'switch')?.sensor
								?.component}
						/>
					</div>
					<div class="control-flex-column flex-1">
						<ControlOnOff {device} {status} {settings} isInSlot useV2Components={true} />
					</div>
				</div>
			{:else if emHasSwitch && !emHasSwitchAddon}
				<ControlOnOff {device} {status} {settings} isWide useV2Components={true} />
			{:else if emHasSwitchAddon}
				<ControlOnOffAddon
					{device}
					{status}
					isWide
					useV2Components={true}
					component={peripheral.find((i) => i.peripheralType == 'switch')?.sensor?.component}
				/>
			{/if}
		{/if}
	</div>
</DeviceViewStateWrapper>
